// GENERATED by `pnpm ndrc gen` — do not edit by hand.
export const CLIENT_LOADERS = {
  appel: () => import('@ndrc-apps/appel/client'),
  crm: () => import('@ndrc-apps/crm/client'),
  inbox: () => import('@ndrc-apps/inbox/client'),
  mini_sites: () => import('@ndrc-apps/mini_sites/client'),
  parcours: () => import('@ndrc-apps/parcours/client'),
  tableur: () => import('@ndrc-apps/tableur/client'),
} as const;
